import React from "react";
import { Navigate } from "react-router-dom";
import useAuthStore from "../store/authStore";
import MainShell from "./mainShell";
import Loading from "./Loading";

interface AuthenticatedRouteProps {
  element: React.ReactNode;
}

const AuthenticatedRoute: React.FC<AuthenticatedRouteProps> = ({ element }) => {
  const {
    isBusyAuthenticating,
    authState,
    checkForValidToken,
  } = useAuthStore();

  if (authState === "notChecked") {
    checkForValidToken();
  }

  if (authState === "checking") {
    return <Loading />;
  }
  if (authState === "invalid") {
    return <Navigate to="/login" replace />;
  }

  if (authState === "valid") {
    return <MainShell>{element}</MainShell>;
  }

  if (isBusyAuthenticating) {
    return <Loading />;
  }
return <Loading />
};

export default AuthenticatedRoute;
